import type { QueryClient } from '@tanstack/react-query'

import type { BookingSessionResponse } from '../../types/booking-session.js'

import { bookingSessionKeys } from './keys.js'

export const syncBookingSessionCache = (
  queryClient: QueryClient,
  session: BookingSessionResponse
): void => {
  queryClient.setQueryData(bookingSessionKeys.detail(session.sessionId), session)
}
